import React, { useState } from 'react';

const C = {
  teal: '#50B8A8', text: '#f8fafc', surface: '#1e293b',
  navySoft: '#2D4A66', blue: '#5186B0',
} as const;

interface BeforeAfterProps {
  originalUrl: string;
  editedCanvasRef: React.Ref<HTMLCanvasElement>;
  width: number;
  height: number;
}

export function BeforeAfter({ originalUrl, editedCanvasRef, width, height }: BeforeAfterProps) {
  const [showOriginal, setShowOriginal] = useState(false);

  const aspect = width > 0 && height > 0 ? height / width : 0.75;
  const maxH = Math.min(500, window.innerHeight * 0.5);
  const displayW = Math.min(600, window.innerWidth - 48);
  const displayH = Math.min(maxH, displayW * aspect);

  return (
    <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
      <div style={{
        position: 'relative', width: displayW, height: displayH,
        borderRadius: 12, overflow: 'hidden', backgroundColor: C.surface,
      }}>
        {/* Edited canvas */}
        <canvas
          ref={editedCanvasRef}
          style={{
            width: '100%', height: '100%', objectFit: 'contain',
            display: showOriginal ? 'none' : 'block',
          }}
        />
        {/* Original image */}
        {showOriginal && (
          <img
            src={originalUrl}
            alt="Original"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        )}
        {/* Label */}
        <div style={{
          position: 'absolute', top: 8, left: 8,
          padding: '4px 10px', borderRadius: 6,
          background: 'rgba(0,0,0,0.6)', color: C.text,
          fontSize: 11, fontWeight: 600, letterSpacing: 0.5,
        }}>
          {showOriginal ? 'ORIGINAL' : 'EDITED'}
        </div>
      </div>
      <button
        onMouseDown={() => setShowOriginal(true)}
        onMouseUp={() => setShowOriginal(false)}
        onMouseLeave={() => setShowOriginal(false)}
        onTouchStart={() => setShowOriginal(true)}
        onTouchEnd={() => setShowOriginal(false)}
        style={{
          padding: '8px 20px', borderRadius: 8,
          border: `1px solid ${C.navySoft}`,
          background: C.surface, color: C.text,
          fontSize: 13, fontWeight: 500, cursor: 'pointer',
        }}
      >
        Hold to see original
      </button>
    </div>
  );
}
